var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon.7f73be9b.png","uri@2x": __webpack_public_path__ + "icon.4fa2ee7c.png","uri@3x": __webpack_public_path__ + "icon.7f73be9b.png",
    width: 231,
    height: 231
});